import { isNullOrUndefined } from '@coveo/bueno';
import { getSearchApiBaseUrl } from '../../api/platform-client.js';
import { fromAnalyticsStateToAnalyticsParams } from '../configuration/analytics-params.js';
export const buildSearchAndFoldingLoadCollectionRequest = (state, navigatorContext, eventDescription) => {
    return {
        accessToken: state.configuration.accessToken,
        organizationId: state.configuration.organizationId,
        url: state.configuration.search.apiBaseUrl ??
            getSearchApiBaseUrl(state.configuration.organizationId, state.configuration.environment),
        locale: state.configuration.search.locale,
        debug: state.debug,
        tab: state.configuration.analytics.originLevel2,
        referrer: navigatorContext.referrer,
        timezone: state.configuration.search.timezone,
        ...(state.advancedSearchQueries?.aq && {
            aq: state.advancedSearchQueries.aq,
        }),
        ...(state.advancedSearchQueries?.cq && {
            cq: state.advancedSearchQueries.cq,
        }),
        ...(state.advancedSearchQueries?.lq && {
            lq: state.advancedSearchQueries.lq,
        }),
        ...(state.advancedSearchQueries?.dq && {
            dq: state.advancedSearchQueries.dq,
        }),
        ...(state.context && {
            context: state.context.contextValues,
        }),
        ...(state.fields &&
            !state.fields.fetchAllFields && {
            fieldsToInclude: state.fields.fieldsToInclude,
        }),
        ...(state.dictionaryFieldContext && {
            dictionaryFieldContext: state.dictionaryFieldContext.contextValues,
        }),
        ...(state.pipeline && {
            pipeline: state.pipeline,
        }),
        ...(state.query && {
            q: state.query.q,
            enableQuerySyntax: state.query.enableQuerySyntax,
        }),
        ...(state.searchHub && {
            searchHub: state.searchHub,
        }),
        ...(state.sortCriteria && {
            sortCriteria: state.sortCriteria,
        }),
        ...(state.configuration.analytics.enabled &&
            fromAnalyticsStateToAnalyticsParams(state.configuration.analytics, navigatorContext, eventDescription)),
        ...(state.excerptLength &&
            !isNullOrUndefined(state.excerptLength.length) && {
            excerptLength: state.excerptLength.length,
        }),
        ...(state.configuration.search.authenticationProviders.length && {
            authentication: state.configuration.search.authenticationProviders.join(','),
        }),
    };
};
